import { render, staticRenderFns } from "./ContestItemList.vue?vue&type=template&id=25d78b5a"
import script from "./ContestItemList.vue?vue&type=script&lang=js"
export * from "./ContestItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports